// Activities with translations in all 8 languages. Span controls Bento grid size.
export const activities = [
  {
    id: "deep-sea-fishing",
    image: "https://images.pexels.com/photos/1687242/pexels-photo-1687242.jpeg",
    span: "lg",
    duration: { no: "4–6 timer", en: "4–6 hours", de: "4–6 Stunden", fr: "4–6 heures", es: "4–6 horas", nl: "4–6 uur", zh: "4–6 小时", th: "4–6 ชั่วโมง" },
    title: { no: "Havfiske", en: "Deep sea fishing", de: "Hochseeangeln", fr: "Pêche en haute mer", es: "Pesca de altura", nl: "Diepzeevissen", zh: "深海捕鱼", th: "ตกปลาทะเลลึก" },
    description: {
      no: "Jakt på kveite, torsk og sei i Lofotens dype farvann med erfaren lokal kaptein.",
      en: "Chase halibut, cod and pollock in Lofoten's deep waters with a seasoned local captain.",
      de: "Jagen Sie auf Heilbutt, Kabeljau und Seelachs in den tiefen Gewässern der Lofoten mit einem erfahrenen lokalen Kapitän.",
      fr: "Traquez flétan, cabillaud et lieu noir dans les eaux profondes des Lofoten avec un capitaine local expérimenté.",
      es: "Pesca fletán, bacalao y carbonero en las aguas profundas de Lofoten con un capitán local experimentado.",
      nl: "Jaag op heilbot, kabeljauw en pollak in de diepe wateren van Lofoten met een ervaren lokale kapitein.",
      zh: "在罗弗敦深海追寻大比目鱼、鳕鱼和青鳕,由经验丰富的本地船长带领。",
      th: "ตกปลาฮาลิบัต ปลาค็อด และปลาพอลล็อกในน่านน้ำลึกโลโฟเทนกับกัปตันท้องถิ่นที่มากประสบการณ์",
    },
  },
  {
    id: "whale-safari",
    image: "https://images.pexels.com/photos/34114527/pexels-photo-34114527.jpeg",
    span: "lg",
    duration: { no: "5–7 timer", en: "5–7 hours", de: "5–7 Stunden", fr: "5–7 heures", es: "5–7 horas", nl: "5–7 uur", zh: "5–7 小时", th: "5–7 ชั่วโมง" },
    title: { no: "Hvalsafari", en: "Whale safari", de: "Walsafari", fr: "Safari baleines", es: "Safari de ballenas", nl: "Walvissafari", zh: "观鲸之旅", th: "ซาฟารีวาฬ" },
    description: {
      no: "Møt spekkhoggere og knølhvaler på nært hold i sesongen (november–januar).",
      en: "Encounter orcas and humpback whales up close in season (November–January).",
      de: "Begegnen Sie Orcas und Buckelwalen aus nächster Nähe in der Saison (November–Januar).",
      fr: "Rencontrez orques et baleines à bosse de près en saison (novembre–janvier).",
      es: "Encuentros cercanos con orcas y ballenas jorobadas en temporada (noviembre–enero).",
      nl: "Ontmoet orka's en bultruggen van dichtbij in het seizoen (november–januari).",
      zh: "近距离观赏虎鲸与座头鲸(11 月至 1 月)。",
      th: "พบวาฬเพชฌฆาตและวาฬหลังค่อมใกล้ชิดในฤดูกาล (พฤศจิกายน–มกราคม)",
    },
  },
  {
    id: "northern-lights",
    image: "https://images.unsplash.com/photo-1526265710340-da2c0d3fa516",
    span: "md",
    duration: { no: "3–5 timer", en: "3–5 hours", de: "3–5 Stunden", fr: "3–5 heures", es: "3–5 horas", nl: "3–5 uur", zh: "3–5 小时", th: "3–5 ชั่วโมง" },
    title: { no: "Nordlys", en: "Northern lights", de: "Nordlichter", fr: "Aurores boréales", es: "Auroras boreales", nl: "Noorderlicht", zh: "北极光", th: "แสงเหนือ" },
    description: {
      no: "Uforstyrret 360° utsikt fra havet — kveldens mest magiske forestilling.",
      en: "Unobstructed 360° views from the sea — the night's most magical show.",
      de: "Ungestörter 360°-Blick vom Meer — das magischste Schauspiel der Nacht.",
      fr: "Vue à 360° dégagée depuis la mer — le spectacle le plus magique de la nuit.",
      es: "Vistas 360° sin obstáculos desde el mar — el espectáculo más mágico de la noche.",
      nl: "Onbelemmerd 360°-uitzicht vanaf zee — het magischste schouwspel van de nacht.",
      zh: "海上无遮挡的 360° 视野 — 夜晚最神奇的表演。",
      th: "มุมมอง 360° ไร้สิ่งกีดขวางจากทะเล — การแสดงที่น่าอัศจรรย์ที่สุดในคืนนั้น",
    },
  },
  {
    id: "crab-fishing",
    image: "https://images.pexels.com/photos/33628180/pexels-photo-33628180.jpeg",
    span: "sm",
    duration: { no: "2–3 timer", en: "2–3 hours", de: "2–3 Stunden", fr: "2–3 heures", es: "2–3 horas", nl: "2–3 uur", zh: "2–3 小时", th: "2–3 ชั่วโมง" },
    title: { no: "Krabbefiske", en: "Crab fishing", de: "Krabbenfischen", fr: "Pêche au crabe", es: "Pesca de cangrejo", nl: "Krabvissen", zh: "捕蟹体验", th: "จับปู" },
    description: {
      no: "Fang kongekrabbe og taskekrabbe — perfekt familietur med smaking om bord.",
      en: "Catch king crab and brown crab — perfect family trip with on-board tasting.",
      de: "Fangen Sie Königskrabben und Taschenkrebse — perfekt für Familien mit Verkostung an Bord.",
      fr: "Attrapez crabe royal et tourteau — idéal en famille avec dégustation à bord.",
      es: "Captura cangrejo real y buey de mar — salida ideal para familias con degustación a bordo.",
      nl: "Vang koningskrab en Noordzeekrab — perfecte gezinstrip met proeverij aan boord.",
      zh: "捕捉帝王蟹与黄道蟹 — 船上现场品尝,最适合家庭出游。",
      th: "จับปูคิงแครบและปูน้ำตาล — ทริปครอบครัวที่สมบูรณ์แบบพร้อมชิมบนเรือ",
    },
  },
  {
    id: "sightseeing",
    image: "https://images.unsplash.com/photo-1526897498656-6dc773408c52",
    span: "sm",
    duration: { no: "2–4 timer", en: "2–4 hours", de: "2–4 Stunden", fr: "2–4 heures", es: "2–4 horas", nl: "2–4 uur", zh: "2–4 小时", th: "2–4 ชั่วโมง" },
    title: { no: "Sightseeing", en: "Sightseeing in Lofoten", de: "Sightseeing auf den Lofoten", fr: "Visite des Lofoten", es: "Recorrido por Lofoten", nl: "Sightseeing op Lofoten", zh: "罗弗敦观光", th: "ชมวิวโลโฟเทน" },
    description: {
      no: "De mest spektakulære fjellene og fiskevær sett fra den vakreste siden.",
      en: "The most spectacular peaks and fishing villages seen from their best side.",
      de: "Die spektakulärsten Gipfel und Fischerdörfer von ihrer schönsten Seite.",
      fr: "Les sommets et villages de pêcheurs les plus spectaculaires vus sous leur meilleur angle.",
      es: "Los picos y aldeas pesqueras más espectaculares vistos desde su mejor ángulo.",
      nl: "De meest spectaculaire bergen en vissersdorpjes vanaf hun mooiste kant.",
      zh: "从最美丽的角度欣赏最壮丽的山峰与渔村。",
      th: "ยอดเขาและหมู่บ้านชาวประมงอันน่าตื่นตาจากมุมมองที่สวยที่สุด",
    },
  },
  {
    id: "diving",
    image: "https://images.unsplash.com/photo-1612764324168-7a3a318e0cbb",
    span: "sm",
    duration: { no: "3–4 timer", en: "3–4 hours", de: "3–4 Stunden", fr: "3–4 heures", es: "3–4 horas", nl: "3–4 uur", zh: "3–4 小时", th: "3–4 ชั่วโมง" },
    title: { no: "Dykking", en: "Diving", de: "Tauchen", fr: "Plongée", es: "Buceo", nl: "Duiken", zh: "潜水", th: "ดำน้ำ" },
    description: {
      no: "Klart arktisk vann, tareskog og rikt marint liv. Sertifiserte guider.",
      en: "Clear arctic waters, kelp forests and rich marine life. Certified guides.",
      de: "Klares arktisches Wasser, Seetangwälder und reiches Meeresleben. Zertifizierte Guides.",
      fr: "Eaux arctiques limpides, forêts de kelp et vie marine abondante. Guides certifiés.",
      es: "Aguas árticas cristalinas, bosques de kelp y rica vida marina. Guías certificados.",
      nl: "Helder arctisch water, kelpwouden en rijk zeeleven. Gecertificeerde gidsen.",
      zh: "清澈的北极海水、海藻森林与丰富海洋生物,持证向导带队。",
      th: "น้ำอาร์กติกใสแจ๋ว ป่าสาหร่ายและสิ่งมีชีวิตทะเลหลากหลาย ไกด์มีใบอนุญาต",
    },
  },
  {
    id: "surfing",
    image: "https://images.pexels.com/photos/10588489/pexels-photo-10588489.jpeg",
    span: "sm",
    duration: { no: "Halv dag", en: "Half day", de: "Halbtag", fr: "Demi-journée", es: "Medio día", nl: "Halve dag", zh: "半日", th: "ครึ่งวัน" },
    title: { no: "Surfing / Paddleboard", en: "Surfing / Paddleboard", de: "Surfen / SUP", fr: "Surf / Paddle", es: "Surf / Paddleboard", nl: "Surfen / Paddleboard", zh: "冲浪 / 桨板", th: "เซิร์ฟ / พายบอร์ด" },
    description: {
      no: "Legendariske bølger ved Unstad eller rolige paddleboard-turer i skjermede bukter.",
      en: "Legendary Unstad waves or calm paddleboard sessions in sheltered coves.",
      de: "Legendäre Wellen in Unstad oder ruhige SUP-Touren in geschützten Buchten.",
      fr: "Vagues légendaires d'Unstad ou sessions de paddle tranquilles dans des criques abritées.",
      es: "Olas legendarias de Unstad o sesiones de paddleboard tranquilas en calas protegidas.",
      nl: "Legendarische golven bij Unstad of rustige paddleboardsessies in beschutte baaien.",
      zh: "传奇的 Unstad 海浪,或在避风海湾体验宁静的桨板之旅。",
      th: "คลื่นระดับตำนานที่ Unstad หรือพายบอร์ดผ่อนคลายในอ่าวกำบังลม",
    },
  },
  {
    id: "kayaking",
    image: "https://images.pexels.com/photos/10588489/pexels-photo-10588489.jpeg",
    span: "sm",
    duration: { no: "2–4 timer", en: "2–4 hours", de: "2–4 Stunden", fr: "2–4 heures", es: "2–4 horas", nl: "2–4 uur", zh: "2–4 小时", th: "2–4 ชั่วโมง" },
    title: { no: "Kajakk", en: "Kayaking tours", de: "Kajaktouren", fr: "Sorties kayak", es: "Kayak", nl: "Kajaktochten", zh: "皮划艇", th: "พายเรือคายัค" },
    description: {
      no: "Stille padleturer mellom øyer og fiskevær — nær naturen, lavt tempo.",
      en: "Silent paddling between islands and villages — close to nature, slow pace.",
      de: "Stille Paddeltouren zwischen Inseln und Dörfern — naturnah und entspannt.",
      fr: "Pagayages silencieux entre îles et villages — proche de la nature, rythme tranquille.",
      es: "Paladeo silencioso entre islas y aldeas — cerca de la naturaleza, ritmo pausado.",
      nl: "Stille peddeltochten tussen eilanden en dorpen — dicht bij de natuur, rustig tempo.",
      zh: "在岛屿与村落间静静划行 — 贴近自然、慢节奏。",
      th: "พายเงียบ ๆ ระหว่างเกาะและหมู่บ้าน — ใกล้ชิดธรรมชาติ จังหวะช้า",
    },
  },
  {
    id: "rib-safari",
    image: "https://images.unsplash.com/photo-1612764324168-7a3a318e0cbb",
    span: "sm",
    duration: { no: "1,5–3 timer", en: "1.5–3 hours", de: "1,5–3 Stunden", fr: "1,5–3 heures", es: "1,5–3 horas", nl: "1,5–3 uur", zh: "1.5–3 小时", th: "1.5–3 ชั่วโมง" },
    title: { no: "RIB-safari", en: "RIB & boat safaris", de: "RIB- & Bootssafaris", fr: "Safaris RIB", es: "Safaris en RIB", nl: "RIB & bootsafari's", zh: "RIB 快艇探险", th: "ซาฟารีเรือ RIB" },
    description: {
      no: "Adrenalin og vind i håret — rask båtsafari med stopp for foto.",
      en: "Adrenaline and wind in your hair — fast safari with photo stops.",
      de: "Adrenalin und Wind im Haar — schnelle Safari mit Fotostopps.",
      fr: "Adrénaline et vent dans les cheveux — safari rapide avec arrêts photo.",
      es: "Adrenalina y viento en el cabello — safari rápido con paradas para fotos.",
      nl: "Adrenaline en wind in het haar — snelle safari met fotostops.",
      zh: "风驰电掣,享受肾上腺素 — 快速水上探险并停靠拍照。",
      th: "อะดรีนาลีนและลมในผม — ซาฟารีเร็วพร้อมจุดถ่ายรูป",
    },
  },
  {
    id: "wildlife",
    image: "https://images.unsplash.com/photo-1665021924574-8d02ddd8f6e3",
    span: "md",
    duration: { no: "3–4 timer", en: "3–4 hours", de: "3–4 Stunden", fr: "3–4 heures", es: "3–4 horas", nl: "3–4 uur", zh: "3–4 小时", th: "3–4 ชั่วโมง" },
    title: { no: "Fugle- og dyrelivsturer", en: "Wildlife & bird watching", de: "Tier- & Vogelbeobachtung", fr: "Faune & ornithologie", es: "Fauna y aves", nl: "Wildlife & vogelspotten", zh: "野生动物与观鸟", th: "ดูสัตว์ป่าและนก" },
    description: {
      no: "Havørn, lundefugl, oter og sel — lokale guider med kikkert og kamera.",
      en: "Sea eagles, puffins, otters and seals — local guides with optics.",
      de: "Seeadler, Papageitaucher, Otter und Robben — lokale Guides mit Optik.",
      fr: "Pygargues, macareux, loutres et phoques — guides locaux équipés en optique.",
      es: "Pigargos, frailecillos, nutrias y focas — guías locales con ópticas.",
      nl: "Zeearenden, papegaaiduikers, otters en zeehonden — lokale gidsen met optiek.",
      zh: "海雕、海鹦、水獭与海豹 — 本地向导备有观察镜。",
      th: "นกอินทรีทะเล นกพัฟฟิน นาก และแมวน้ำ — ไกด์ท้องถิ่นพร้อมกล้อง",
    },
  },
  {
    id: "photography",
    image: "https://images.unsplash.com/photo-1526265710340-da2c0d3fa516",
    span: "sm",
    duration: { no: "Fleksibelt", en: "Flexible", de: "Flexibel", fr: "Flexible", es: "Flexible", nl: "Flexibel", zh: "灵活", th: "ยืดหยุ่น" },
    title: { no: "Fototurer", en: "Photography tours", de: "Fototouren", fr: "Sorties photo", es: "Tours fotográficos", nl: "Fototours", zh: "摄影之旅", th: "ทริปถ่ายภาพ" },
    description: {
      no: "Skreddersydd for fotografer — timing, lys og tilgang til de beste punktene.",
      en: "Tailored for photographers — timing, light and access to hidden vantage points.",
      de: "Maßgeschneidert für Fotografen — Timing, Licht und Zugang zu versteckten Aussichtspunkten.",
      fr: "Sur mesure pour photographes — timing, lumière et accès aux meilleurs points de vue.",
      es: "A medida para fotógrafos — tiempos, luz y acceso a los mejores miradores.",
      nl: "Op maat voor fotografen — timing, licht en toegang tot de beste uitzichtpunten.",
      zh: "为摄影师量身定制 — 掌握时机、光线与最佳机位。",
      th: "ออกแบบสำหรับช่างภาพ — จังหวะ แสง และเข้าถึงจุดชมวิวที่ดีที่สุด",
    },
  },
  {
    id: "midnight-sun",
    image: "https://images.unsplash.com/photo-1656490247857-cfad59341c33",
    span: "md",
    duration: { no: "3–5 timer", en: "3–5 hours", de: "3–5 Stunden", fr: "3–5 heures", es: "3–5 horas", nl: "3–5 uur", zh: "3–5 小时", th: "3–5 ชั่วโมง" },
    title: { no: "Midnattssol", en: "Midnight sun trips", de: "Mitternachtssonne", fr: "Soleil de minuit", es: "Sol de medianoche", nl: "Middernachtzon", zh: "午夜阳光", th: "พระอาทิตย์เที่ยงคืน" },
    description: {
      no: "Gyllent lys midt på natten — en opplevelse du aldri glemmer (mai–juli).",
      en: "Golden light in the middle of the night — unforgettable (May–July).",
      de: "Goldenes Licht mitten in der Nacht — unvergesslich (Mai–Juli).",
      fr: "Lumière dorée en pleine nuit — inoubliable (mai–juillet).",
      es: "Luz dorada a medianoche — inolvidable (mayo–julio).",
      nl: "Gouden licht midden in de nacht — onvergetelijk (mei–juli).",
      zh: "深夜里的金色光芒 — 毕生难忘(5 月至 7 月)。",
      th: "แสงสีทองยามเที่ยงคืน — ไม่มีวันลืม (พฤษภาคม–กรกฎาคม)",
    },
  },
  {
    id: "fjord-cruise",
    image: "https://images.unsplash.com/photo-1656490247857-cfad59341c33",
    span: "sm",
    duration: { no: "4–6 timer", en: "4–6 hours", de: "4–6 Stunden", fr: "4–6 heures", es: "4–6 horas", nl: "4–6 uur", zh: "4–6 小时", th: "4–6 ชั่วโมง" },
    title: { no: "Fjordcruise", en: "Fjord cruises", de: "Fjordkreuzfahrten", fr: "Croisières fjords", es: "Cruceros por fiordos", nl: "Fjordcruises", zh: "峡湾巡游", th: "ล่องเรือฟยอร์ด" },
    description: {
      no: "Rolige timer mellom bratte fjellvegger og dype, stille fjorder.",
      en: "Slow hours between steep cliffs and deep, silent fjords.",
      de: "Ruhige Stunden zwischen steilen Felswänden und tiefen, stillen Fjorden.",
      fr: "Des heures paisibles entre falaises abruptes et fjords profonds et silencieux.",
      es: "Horas lentas entre acantilados escarpados y fiordos profundos y silenciosos.",
      nl: "Rustige uren tussen steile kliffen en diepe, stille fjorden.",
      zh: "在陡峭悬崖与深邃寂静的峡湾间缓慢徜徉。",
      th: "ชั่วโมงช้า ๆ ระหว่างหน้าผาสูงชันและฟยอร์ดลึกอันเงียบสงบ",
    },
  },
  {
    id: "snorkeling",
    image: "https://images.pexels.com/photos/10588489/pexels-photo-10588489.jpeg",
    span: "sm",
    duration: { no: "2–3 timer", en: "2–3 hours", de: "2–3 Stunden", fr: "2–3 heures", es: "2–3 horas", nl: "2–3 uur", zh: "2–3 小时", th: "2–3 ชั่วโมง" },
    title: { no: "Snorkling", en: "Snorkeling", de: "Schnorcheln", fr: "Snorkeling", es: "Snorkel", nl: "Snorkelen", zh: "浮潜", th: "ดำน้ำตื้น" },
    description: {
      no: "Rent, klart vann og fargerikt tareliv. Tørrdrakt inkludert.",
      en: "Clear waters and colourful kelp forests. Dry suit included.",
      de: "Klares Wasser und farbenfrohe Seetangwälder. Trockenanzug inklusive.",
      fr: "Eaux limpides et forêts de kelp colorées. Combinaison sèche incluse.",
      es: "Aguas cristalinas y coloridos bosques de kelp. Traje seco incluido.",
      nl: "Helder water en kleurrijke kelpwouden. Droogpak inbegrepen.",
      zh: "清澈海水与色彩斑斓的海藻林。含干式潜水服。",
      th: "น้ำใสและป่าสาหร่ายสีสันสดใส รวมชุดดรายสูท",
    },
  },
  {
    id: "private-luxury",
    image: "https://images.unsplash.com/photo-1612764324168-7a3a318e0cbb",
    span: "lg",
    duration: { no: "Hele dagen", en: "Full day", de: "Ganztägig", fr: "Journée entière", es: "Día completo", nl: "Hele dag", zh: "全天", th: "เต็มวัน" },
    title: { no: "Privat luksustur", en: "Private luxury tours", de: "Private Luxustouren", fr: "Sorties luxe privées", es: "Tours privados de lujo", nl: "Privé luxetours", zh: "私人奢华之旅", th: "ทริปหรูส่วนตัว" },
    description: {
      no: "Full båt, skreddersydd rute, catering og dedikert vert. Din dag, din plan.",
      en: "Whole boat, tailored route, catering and dedicated host. Your day, your plan.",
      de: "Ganzes Boot, maßgeschneiderte Route, Catering und persönlicher Host. Ihr Tag, Ihr Plan.",
      fr: "Bateau entier, itinéraire sur mesure, restauration et hôte dédié. Votre jour, votre plan.",
      es: "Barco completo, ruta a medida, catering y anfitrión dedicado. Tu día, tu plan.",
      nl: "Hele boot, route op maat, catering en toegewijde gastheer. Uw dag, uw plan.",
      zh: "整艘包船、定制路线、餐饮服务及专属主持。您的日程,您来定。",
      th: "เหมาเรือทั้งลำ เส้นทางเฉพาะ อาหารและโฮสต์ส่วนตัว วันของคุณ แผนของคุณ",
    },
  },
  {
    id: "custom-group",
    image: "https://images.pexels.com/photos/33628180/pexels-photo-33628180.jpeg",
    span: "md",
    duration: { no: "Fleksibelt", en: "Flexible", de: "Flexibel", fr: "Flexible", es: "Flexible", nl: "Flexibel", zh: "灵活", th: "ยืดหยุ่น" },
    title: { no: "Skreddersydd gruppe", en: "Custom group experiences", de: "Individuelle Gruppenerlebnisse", fr: "Expériences de groupe sur mesure", es: "Experiencias para grupos a medida", nl: "Groepservaringen op maat", zh: "团体定制体验", th: "ประสบการณ์กลุ่มตามสั่ง" },
    description: {
      no: "Bedrift, familie eller venner — vi designer opplevelsen for dere.",
      en: "Corporate, family or friends — we design the experience around you.",
      de: "Firmen, Familien oder Freunde — wir gestalten das Erlebnis für Sie.",
      fr: "Entreprise, famille ou amis — nous concevons l'expérience pour vous.",
      es: "Empresas, familia o amigos — diseñamos la experiencia a tu medida.",
      nl: "Bedrijf, familie of vrienden — wij ontwerpen de ervaring voor u.",
      zh: "企业团建、家人或朋友 — 我们为您量身设计体验。",
      th: "องค์กร ครอบครัว หรือเพื่อน ๆ — เราออกแบบประสบการณ์ให้คุณ",
    },
  },
  {
    id: "drone-filming",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    span: "md",
    duration: { no: "Tillegg til tur", en: "Add-on", de: "Zusatzleistung", fr: "Option", es: "Complemento", nl: "Bijboeken", zh: "附加项目", th: "บริการเสริม" },
    title: { no: "Droneopptak", en: "Drone filming", de: "Drohnenaufnahmen", fr: "Prises de vue par drone", es: "Filmación con dron", nl: "Drone-opnames", zh: "无人机拍摄", th: "ถ่ายภาพด้วยโดรน" },
    description: {
      no: "Ønsker du filmatiske dronevideoer fra ekspedisjonen? Vi setter opp profesjonell droneopptak — havørn fra luften, båten i fjorden, nordlys eller surf.",
      en: "Want cinematic drone footage from your expedition? We arrange professional aerial filming — sea eagles from above, the boat in the fjord, northern lights or surf.",
      de: "Möchten Sie filmische Drohnenaufnahmen Ihrer Expedition? Wir organisieren professionelle Luftaufnahmen — Seeadler von oben, das Boot im Fjord, Nordlichter oder Surfen.",
      fr: "Envie de vidéos drone cinématographiques de votre sortie ? Nous organisons des prises de vue aériennes professionnelles — pygargues en vol, bateau dans le fjord, aurores ou surf.",
      es: "¿Quieres vídeos aéreos cinematográficos de tu expedición? Organizamos filmación con dron profesional — pigargos desde el aire, el barco en el fiordo, auroras o surf.",
      nl: "Wilt u filmische dronebeelden van uw expeditie? Wij regelen professionele luchtopnames — zeearenden van bovenaf, de boot in de fjord, noorderlicht of surf.",
      zh: "希望为您的出海行程留下电影级航拍影像?我们提供专业无人机拍摄 — 高空中的海雕、峡湾中的船只、北极光或冲浪画面。",
      th: "อยากได้วิดีโอโดรนสไตล์ภาพยนตร์จากทริปของคุณไหม? เราจัดถ่ายทำทางอากาศมืออาชีพ — นกอินทรีทะเลจากมุมสูง เรือกลางฟยอร์ด แสงเหนือ หรือเซิร์ฟ",
    },
  },
];
